// import React from "react";
// import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@mui/material";
// import { Link as RouterLink, useLocation } from "react-router-dom";

// const generateBreadcrumbs = (pathname) => {
//   const pathnames = pathname
//     .split("/")
//     .filter((segment) => segment && isNaN(Number(segment)));

//   // Remove 'projectDetail' from breadcrumbs
//   const filteredPathnames = pathnames.filter(
//     (segment) => segment !== "projectDetail" && segment !== "timesheet"
//   );

//   return (
//     <MUIBreadcrumbs aria-label="breadcrumb">
//       {filteredPathnames.map((value, index) => {
//         const to = `/${filteredPathnames.slice(0, index + 1).join("/")}`;
//         const isLast = index === filteredPathnames.length - 1;
//         return isLast ? (
//           <Typography color="textPrimary" variant="h6" key={to}>
//             {value.charAt(0).toUpperCase() + value.slice(1).replace("-", " ")}
//           </Typography>
//         ) : (
//           <Link
//             component={RouterLink}
//             to={to}
//             key={to}
//             sx={{
//               color: "gray",
//               fontSize: "0.85rem",
//               textDecoration: "none",
//               "&:hover": {
//                 textDecoration: "underline",
//               },
//             }}
//           >
//             {value.charAt(0).toUpperCase() + value.slice(1).replace("-", " ")}
//           </Link>
//         );
//       })}
//     </MUIBreadcrumbs>
//   );
// };

// const Breadcrumbs = () => {
//   const location = useLocation();
//   return generateBreadcrumbs(location.pathname);
// };

// export default Breadcrumbs;
import React, { useEffect } from "react";
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setprojectName } from "../../selectSlice";



const generateBreadcrumbs = (pathname, projectName) => {
  const pathnames = pathname
    .split("/")
    .filter((segment) => segment && isNaN(Number(segment)));

  const containsProjectDetail = pathnames.includes("projectDetail");
  if (containsProjectDetail) {
    return projectName ? (
      <MUIBreadcrumbs aria-label="breadcrumb">
        <Typography color="textPrimary" variant="h6">
          {projectName}
        </Typography>
      </MUIBreadcrumbs>
    ) : null; // Hide breadcrumbs if projectName is empty
  }
  const customBreadcrumbLabels = {
    "earning-dashboard": "Resource Earning",
  };

  const formatBreadcrumbLabel = (value) => {
    if (customBreadcrumbLabels[value.toLowerCase()]) {
      return customBreadcrumbLabels[value.toLowerCase()];
    }
    return value
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/-/g, " ")
      .replace(/%20/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;

        return isLast ? (
          <Typography color="textPrimary" variant="h6" key={to}>
            {formatBreadcrumbLabel(value)}
          </Typography>
        ) : (
          <Link
            component={RouterLink}
            to={to}
            key={to}
            sx={{
              color: "gray",
              fontSize: "0.85rem",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {formatBreadcrumbLabel(value)}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

const Breadcrumbs = () => {
  const dispatch = useDispatch();
  const projectName =
    useSelector((state) => state.selectOptions?.projectName) || "";
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes("projectDetail")) {
      dispatch(setprojectName("")); // Reset project name when not in projectDetail
    }
  }, [location.pathname, dispatch]);

  return generateBreadcrumbs(location.pathname, projectName);
};

export default Breadcrumbs;

//           "time_logs": [
//               {
//                   "time_logs_id": 5,
//                   "task_id": 2,
//                   "issue_id": null,
//                   "owner_id": 154,
//                   "project_id": 1,
//                   "log_type": "TASK",
//                   "start_time": null,
//                   "end_time": null,
//                   "hours_in_text": "08:00",
//                   "hours": 8,
//                   "billing_type": "BILLABLE",
//                   "notes": "worked on timesheet page and worked on bug fixing ",
//                   "owner_name": "vigneshwaran k",
//                   "added_name": "vigneshwaran k",
//                   "updated_name": null,
//                   "other_log_entries": null,
//                   "project_title": "TT-PMS",
//                   "log_title": "front end development",
//                   "log_date": "2025-03-14"
//               }
//           ]

// "time_logs": [
//               {
//                   "time_logs_id": 6,
//                   "task_id": 2,
//                   "issue_id": null,
//                   "owner_id": 154,
//                   "project_id": 1,
//                   "log_type": "TASK",
//                   "start_time": null,
//                   "end_time": null,
//                   "hours_in_text": "08:00",
//                   "hours": 8,
//                   "billing_type": "BILLABLE",
//                   "notes": "worked on timesheet filter and export page and bug fixing",
//                   "owner_name": "vigneshwaran k",
//                   "added_name": "vigneshwaran k",
//                   "updated_name": null,
//                   "other_log_entries": null,
//                   "project_title": "TT-PMS",
//                   "log_title": "front end development",
//                   "log_date": "2025-03-15"
//               }
//           ]
